import Loader from "./loader";
import Cep from "./cep";
import EventRegister from "./event_register";

class AddressLoader {
  static async load(cep) {
    return await Loader.process(async () => Cep.find(cep), 'Loading address...');
  }

  static async loadAndFill(cep, form) {
    const address = await this.load(cep);
    if (address) {
      form.querySelector("[id*='address_street']").value = address.street;
      form.querySelector("[id*='address_neighborhood']").value = address.neighborhood;
      form.querySelector("[id*='address_city']").value = address.city;
      form.querySelector("[id*='address_state']").value = address.state;
    } else {
      alert("CEP não encontrado ou falha ao carregar os dados.");
    }
  }

  static init() {
    EventRegister.promisseRegister(".zip-code", "blur",  function() {
      const zipCode = this.value.replace(/\D/g, '');
      if (zipCode.length === 8) {
        AddressLoader.loadAndFill(zipCode, this.form);
      }
    });
  }
}

AddressLoader.init();

export default AddressLoader;
